import React, { useEffect, useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import LoginLayout from '../Screen/Layouts/LoginLayouts';
import { ProtectedRoute } from './ProtectedRoute';
// import DashboardContainer from '../Screen/Dashboard/index';
import 'react-toastify/dist/ReactToastify.css';
import { MaintenanceRoute } from './MaintenanceRoute';
import MaintenanceLayout from '../Screen/Layouts/MaintenanceLayout';
import { ToastContainer } from 'react-toastify';
import { ReactNode } from 'react';
import Dashboard from '../Screen/Dashboard/Dashboard';
import SignupForm from '../Screen/Login/SignUpForm';
import Verification from '../Screen/Login/Verification';
import ForgotPassword from '../Screen/Login/ForgotPassword';
import ForgotConfirmEmail from '../Screen/Login/ForgotConfirmEmail';
import Checkout from '../CommonComponents/Checkout';

interface Props {
  user?: Object,
  isMaintenance?: any
  children?: ReactNode
  // any props that come into the component
}


const AllRoutes = ({ user, isMaintenance }: Props) => {
  return (
    <>
      <ToastContainer />
      <Routes>
        {/* @ts-ignore */}
        <Route element={<MaintenanceRoute isMaintenance={isMaintenance} />}>

          {/* ============= LOGEDOUT ROUTES ========== */}
          <Route index element={<Navigate to={'/app'} />} />
          <Route path="app">
            <Route index element={<LoginLayout />} />
            <Route path="login" element={<LoginLayout />} />
            {/* <Route path="signin" element={<LoginForm />} /> */}
            <Route path="create-account" element={<SignupForm />} />
            <Route path="verification" element={<Verification />} />
            <Route path="forgotpassword" element={<ForgotPassword />} />
            <Route path="forgotemail" element={<ForgotConfirmEmail />} />
            <Route path="checkout" element={<Checkout />} />
            {/* </Route> */}
            {/* ============= LOGEDIN ROUTES ========== */}
            {/* @ts-ignore */}
            <Route element={<ProtectedRoute isAllowed={!!user} />}>
              <Route path="user-dashboard" element={<Dashboard />} />
            </Route>
          </Route>
          {/* ============= COMMON ROUTES ========== */}

        </Route>
        <Route path="*" element={<h1>404 Page Not Found</h1>} />
        <Route path="maintenance" element={<MaintenanceLayout />} />
      </Routes>
    </>
  );
};

export default AllRoutes;
